import { render, staticRenderFns } from "./BusquedaBL.vue?vue&type=template&id=38bb85dc"
import script from "./BusquedaBL.vue?vue&type=script&lang=js"
export * from "./BusquedaBL.vue?vue&type=script&lang=js"
import style0 from "./BusquedaBL.vue?vue&type=style&index=0&id=38bb85dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports